// * -------------------------------- NPM --------------------------------------
import React from 'react'

// * -------------------------------- MODULE --------------------------------------
import Input from '../Input/Input'
import {IDateComponent, IInputComponent, InputTypes, ISelectComponent, ITimeComponents} from '../Input/types'
import {IFlexItem} from '../Flex/FlexItem'
import {IconName} from '../../../services/icon'

export type Props = IInputComponent | ISelectComponent | IDateComponent | ITimeComponents

/*
  * A simple wrapper of Input
  ! Use FilterInput when you want to use Input as Filter
*/

const FilterInput = (props: Props & IFlexItem) => {
	// * ----------------------------------------------------------------------------------------
	// * -------------------------------- INIT --------------------------------------
	// * ----------------------------------------------------------------------------------------
	const inputIcons: { [key in InputTypes]: IconName } = {
		input: 'search',
		date: 'calendar',
		select: 'filter',
	}

	// * ----------------------------------------------------------------------------------------
	// * -------------------------------- RENDERs --------------------------------------
	// * ----------------------------------------------------------------------------------------
	return <Input hideInfoFeedback={true} {...props} icon={inputIcons[props.kind]}/>
}

export default FilterInput
